export default "__VITE_ASSET__D$Eialh9__"